import React, { useState, useEffect } from "react";

const Dropdown = (props) => {
    const [isOpen, setIsOpen] = useState(false);
    const [items, setItems] = useState(props.items || []);
    const [title, setTitle] = useState(props.title || "");
    const [selectionCompleted, setSelectionCompleted] = useState(props.selectionCompleted || false);

    // Handle click outside the dropdown
    const handleClickOutside = () => {
        setIsOpen(false);
    };

    // Handle dropdown toggle
    const isDropDownOpen = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setIsOpen((prev) => !prev);
    };

    // Handle item selection
    const isItemSelected = (itemInput, e) => {
        if (e) {
            e.preventDefault();
            e.stopPropagation();
        }

        setTitle("");
        setSelectionCompleted(false);

        // Create a new array and update the selected property immutably
        const updatedItems = items.map((item) => {
            if (item.value === itemInput.value) {
                return { ...item, selected: "true" }; // Create a new object with updated property
            }
            return { ...item, selected: "false" }; // Create a new object with updated property
        });

        setItems(updatedItems);
        setTitle(itemInput.label);
        setSelectionCompleted(true);
        setIsOpen(false);

        // Call parent handler
        props.handleSelectBox(itemInput);
    };

    // Add and remove event listeners for clicks
    useEffect(() => {
        const handleClick = (e) => {
            if (e.target.className === "display-selection" && !isOpen) {
                handleClickOutside();
            } else if (e.target.className !== "display-selection" && isOpen) {
                handleClickOutside();
            }
        };

        document.addEventListener("click", handleClick, false);

        return () => {
            document.removeEventListener("click", handleClick, false);
        };
    }, [isOpen]);

    // Handle pre-selected modifiers
    useEffect(() => {
        if (props.selectedModifiers) {
            const updatedItems = items.map((item) => {
                if (props.selectedModifiers.includes(item.value)) {
                    return { ...item, selected: "true" }; // Create a new object with updated property
                }
                return { ...item, selected: "false" };
            });
            setItems(updatedItems);
        }
    }, [props.selectedModifiers, items]);

    return (
        <div className="drop-down-container wrapper">
            <button tabIndex="0"
                type="button"
                className={`dropdown Option drop-down-width ${selectionCompleted}`}
                onClick={isDropDownOpen}
                onKeyDown={(e) => {
                    if (e.key === "Enter") {
                        isDropDownOpen(e);
                    }
                }}
            >
                <div className="display-selection">{title}</div>
                {isOpen ? (
                    <div className="arrow-position"></div>
                ) : (
                    <div className="arrowdown-position"></div>
                )}
            </button>

            {isOpen && (
                <div className="list-overflow">
                    {items.map((item) => (
                        <div
                            className={
                                item.selected === "true"
                                    ? "select-icon drop-down-item"
                                    : "drop-down-item"
                            }
                            id={item.value}
                            key={item.value}
                            onClick={(e) => isItemSelected(item, e)}
                            tabIndex="0"
                        >
                            {item.label}
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default Dropdown;
